import { translateContent } from "../../Common/Appcommon";

export const modalContent = {
    "book_calendar": [
        {
            label: "Action Name",
            name: "action_name",
            type: "text",
        },
        {
            label: "Calendar App Selection",
            name: "calendar",
            type: "dropdown",
            options: [
                {
                    label: "Google Calendar",
                    value: "gcalendar"
                },
                {
                    label: "GHL Calendar",
                    value: "ghl_calendar"
                },
                {
                    label: "Cal.com",
                    value: "cal.com"
                },
            ]
        },
        // {
        //     label: "Connected Accounts",
        //     name: "connected_accounts",
        //     type: "dropdown",
        //     options: [
        //         {
        //             label: "Google Calendar",
        //             value: "gcalendar"
        //         },
        //         {
        //             label: "GHL Calendar",
        //             value: "ghl_calendar"
        //         },
        //         {
        //             label: "Cal.com",
        //             value: "cal.com"
        //         },
        //     ]
        // },
        {
            label: "Calendar",
            name: "calendar_type",
            type: "dropdown",
            options: [
            ]
        },
        {
            label: "Calendar Date Selection",
            name: "calendar_date_type",
            type: "dropdown",
            options: [
                {
                    label: "Current Date",
                    value: "current_date"
                },
                {
                    label: "Custom Date",
                    value: "custom_date"
                },
            ]
        },
        /* {
            label: "Call Type",
            name: "call_type",
            type: "dropdown",
            options: [
                {
                    label: "Inbound",
                    value: "inbound"
                },
                {
                    label: "Outbound",
                    value: "outbound",
                },
                {
                    label: "Both",
                    value: "both",
                },
            ]
        }, */
        // {
        //     label: "Meeting Location",
        //     name: "location",
        //     type: "dropdown",
        //     options: [
        //         {
        //             label: "Google Meet",
        //             value: "gmeet"
        //         },
        //         {
        //             label: "Zoom Meet",
        //             value: "zmeet",
        //         },
        //         {
        //             label: "Custom",
        //             value: "custom",
        //         },
        //     ]
        // },
        {
            name: "start_date",
            type: "date",
        },
        {
            label: "Duration",
            name: "duration",
            type: "number",
            info: 'Meeting time duration in minutes.',
            infoNeeded: true,
            default: 45
        },
        {
            label: "Slots Per Day",
            name: "slots_per_day",
            type: "number",
            info:'Daily available booking slots.',
            infoNeeded: true,
            default: 8
        },
        {
            label: "Break Between Slots In Mins",
            name: "slots_break",
            type: "number",
            info:'Time buffer between scheduled slots in minutes.',
            infoNeeded:true,
            default: 15
        },
        {
            label: "Booking Window",
            name: "booking_window",
            type: "number",
            info: 'Bookings can be made for a set number of days starting from the current date.',
            infoNeeded:true,
            default: 10
        },
        {
            label: "Working Hours",
            name: "working_hours",
            type: "week",
        },
        {
            label: "Delay",
            name: "delay",
            type: "number",
            info:'',
            infoNeeded: false,
        },
    ]
};
export const modalHeaders = {
    "book_calendar": [
        {
            header: "Calendar",
            description: "Check availability and schedule appointments through the Book Calendar action.",
        },
    ],
    "send_sms": [
        {
            header: "Send SMS",
            description: "Send appointment details via SMS",
            warning: "Please connect your Twilio account before adding an action.",
        }
    ],
    "send_email": [
        {
            header: "Send Email",
            description: "Send appointment details via Email",
            warning: "Please connect your Email SMTP account before adding an action.",
        }
    ],
    "transfer_call":[
        {
            header: "Transfer Call",
            description: "Transfer call to a number or human", 
        }
    ],
    "end_call":[
        {
            header: "End Call Message",
            description: "This is the message that the assistant will say if the call is ended.", 
        }
    ],
    "extract_info":[
        {
            header: "Extract Info",
            description: "Capture relevant information from the call conversations", 
        }
    ],
    "vmail_message":[
        {
            header: "Voicemail Message",
            description: "This is the message that the assistant will say if the call is forwarded to voicemail.", 
        }
    ],
    "custom_action":[
        {
            header: "Custom Action",
            description: "Fetch or update data from external tools during the call.", 
        }
    ],
    "Post_Call_Event":[
        {
            header: "Post-Call Event",
            description: "Trigger a webhook to send call event details after the call ends.", 
        }
    ]
}
export const afterCallActions = [
    {
        label: "Send SMS",
        value: "send_sms",
        icon: <i class="fi fi-rr-comment-sms"></i>,
    },
    {
        label: "Send Email",
        value: "send_email",
        icon: <i class="fi fi-rr-envelope"></i>,
    },
    {
        label: "Extract Info",
        value: "extract_info",
        icon: <i class="fi fi-rr-info"></i>
    },
    {
        label: "Post Call Event",
        value: "Post_Call_Event",
        icon: <i class="fi fi-rr-webhook"></i>
    }
    // {
    //     label: "Custom Action",
    //     value: "custom_action",
    //     icon: <i class="fi fi-rs-trash"></i>,
    // },
];
export  const duringCallActions = [
    {
        label: "Call Transfer",
        value: "transfer_call",
        icon: <i class="fi fi-br-call-outgoing"></i>,
    },
    {
        label: "End Call",
        value: "end_call",
        icon: <i class="fi fi-br-phone-slash"></i>,
    },
    // {
    //     label: "Check Calendar",
    //     value: "check_calendar"
    // },
    {
        label: "Book Calendar",
        value: "book_calendar",
        icon: <i class="fi fi-rr-calendar-lines-pen"></i>,
    },
    /* {
        label: "Voicemail Message",
        value: "vmail_message",
        icon: <i class="fi fi-rr-salary-alt"></i>,
    }, */
    {
        label: "Custom Action",
        value: "custom_action",
        icon: <i class="fi fi-rr-tools"></i>,
    },
];

export const timeoptions = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
    { value: 6, label: "6" },
    { value: 7, label: "7" },
    { value: 8, label: "8" },
    { value: 9, label: "9" },
    { value: 10, label: "10" },
];

export const callOptions = [
    { value: "cold_transfer", label: "Cold transfer", description: "AI transfers the call to the next user without a debrief.." },
    { value: "warm_transfer", label: "Warm transfer", description: "AI provides a debrief to the next user after transferring the call." },
];

export const defaultStructureData = `
You will be given a call transcript and the AI system prompt. 
Extract the following Key Performance Indicators (KPIs):

    1. **Call Rating**
    - **Type**: Dropdown
    - **Options**: Excellent, Good, Average, Poor, Very Poor
    - **Purpose**: Measures customer satisfaction with service quality; “Excellent” shows strong customer happiness and loyalty.

    2. **Call Sentiment**
    - **Type**: Dropdown
    - **Options**: Very Positive, Positive, Neutral, Negative, Very Negative
    - **Purpose**: Gauges customer sentiment; “Very Positive” indicates high satisfaction and loyalty.`;

    export const backgroundSoundOptions = {
        "vapi": [
            { value: "off", label: "Off" },
            { value: "office", label: "Office" },
            { value: null, label: "Default" },
        ],
        "retell" : [
            { value: null, label: "None" }, 
            { value: "coffee-shop", label: "Coffee Shop" },
            { value: "convention-hall", label: "Convention Hall" },
            { value: "summer-outdoor", label: "Summer Outdoor" },
            { value: "mountain-outdoor", label: "Mountain Outdoor" },
            { value: "static-noise", label: "Static Noise" },
            { value: "call-center", label: "Call Center" }
        ],
        'bland' : []
    }

    export const providerHideFields = {
        "vapi": ["detect_emotion"],
        "retell": ["detect_emotion", "filter_background_noice"],
        "bland":[], 
    }

    export const getAgentFields = (fieldNames, isAllowEdit, providerName, knowledgeBase, dropDownName = "openai",pickListItems) => {
        return {
            configViewFieldSave :[
                {
                    label: "AI Agent Name",
                    name: "Agent Name",
                    datalabel: fieldNames['Agent_Name'],
                    type: "text",
                    description: "",
                    placeholder: "Name Here",
                    required: true,
                    isDisabled: !isAllowEdit,
                },
                {
                    label: "Voice",
                    name: "Voice",
                    datalabel: fieldNames['voice_id'],
                    type: "text",
                    description: "Voice.",
                    placeholder: "Choose a voice",
                    required: false,
                    isDisabled: !isAllowEdit,
                    autoComplete :"off"
                },
                {
                    label: "First Message",
                    name: "Call Start Message",
                    datalabel: fieldNames['Call_Start_Message'],
                    type: "textarea",
                    description: "The first message that the AI Agent will say.",
                    placeholder: "First Message Here",
                    required: true,
                    isDisabled: !isAllowEdit,
                },
                {
                    label: "System Prompt",
                    name: "System Prompt",
                    datalabel: fieldNames['System_Prompt'],
                    type: "mention",
                    description: "Give AI agents intelligence with information (context, role, personality, instructions, etc.)",
                    placeholder: "System Prompt Here",
                    required: false,
                    isDisabled: !isAllowEdit,
                }
            ],
            roleTabFields : [
                {
                    label: "First Message",
                    name: providerName == "vapi" ?  "Call Start Message" : "Call_Start_Message" ,
                    datalabel: providerName == "vapi" ? fieldNames['Call_Start_Message'] : "Call_Start_Message",
                    type: providerName == "vapi" ? "mention" : "dropdown",
                    description: "The first message that the AI Agent will say.",
                    placeholder: "First Message Here",
                    required: true,
                    isDisabled: !isAllowEdit,
                    options : 
                        [
                            { value: "0", label: "User Initiates: AI remains silent until users speak first." },
                            { value: "1", label: "AI Initiates: AI begins with a dynamic begin message." },
                            { value: "msg", label: "AI Initiates: AI begins with your defined begin message." },
                        ],
                    subFields : [
                        {
                            label: "Welcome Message",
                            name: "Call_End_Message",
                            datalabel: fieldNames['Call_End_Message'],
                            type: "mention",
                            placeholder: "Add your begin message",
                            required: true,
                            isDisabled: !isAllowEdit,
                        }
                    ]
                },
                // {
                //     label: "Knowledge Base",
                //     name: "knowledgebase",
                //     datalabel: fieldNames['knowledgebase'],
                //     type: "dropdown",
                //     description: "knowledgebase",
                //     placeholder: "Knowledge Base Here",
                //     required: false,
                //     options : knowledgeBase || [],
                //     isDisabled: !isAllowEdit,
                //     allowMulti:true,
                // },
                {
                    label: "Task Prompt",
                    name: "System Prompt",
                    datalabel: fieldNames['System_Prompt'],
                    type: "mention",
                    description: "Give AI agents intelligence with information (context, role, personality, instructions, etc.)",
                    placeholder: "System Prompt Here",
                    required: true,
                    isDisabled: !isAllowEdit,
                }
            ],
            agentInfoFields:[
                {
                    label: "Agent Name",
                    name: "Agent Name",
                    datalabel: fieldNames['Agent_Name'],
                    type: "text",
                    description: "",
                    placeholder: "Name Here",
                    required: true,
                    isDisabled: !isAllowEdit,
                },
                {
                    label: "Knowledge Base",
                    name: "knowledgebase",
                    datalabel: fieldNames['knowledgebase'],
                    type: "dropdown",
                    description: "knowledgebase",
                    placeholder: "Knowledge Base Here",
                    required: false,
                    options : knowledgeBase || [],
                    isDisabled: !isAllowEdit,
                    allowMulti:true,
                },
                {
                    label: "Voice",
                    name: "Voice",
                    datalabel: fieldNames['voice_id'],
                    type: "text",
                    description: "Voice.",
                    placeholder: "Choose a voice",
                    required: false,
                    isDisabled: !isAllowEdit,
                    autoComplete :"off"
                },
                {
                    label: "Language",
                    name: "language",
                    datalabel: fieldNames['language'],
                    type: "dropdown",
                    description: "Voice.",
                    placeholder: "Choose a language",
                    required: false,
                    isDisabled: !isAllowEdit,
                    options: providerLanguages[providerName], //pickListItems?.["Agent_Master_Language"] ??  ,
                }
            ],
            speechSettingsFields: {
                common :[
                    {
                        label: providerName == "vapi" ? "Background Sound" : "Background Sound",
                        name: "play_background_sound",
                        datalabel: 'play_background_sound',
                        type: "dropdown",
                        description: providerName == "vapi" ? translateContent("vapi.background.sound.desc") : translateContent("retell.background.sound.desc"),
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        options: backgroundSoundOptions[providerName],
                        allowMulti : false,
                        orderNo :providerName == "vapi" ? 1 : "speech" + 3,
                    },
                    {
                        label: providerName == "vapi" ? "Detect Emotion" : "Detect Emotion",
                        name: "detect_emotion",
                        datalabel: 'detect_emotion',
                        type: "switch",
                        description: "Detect Emotio",
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        orderNo : 100,
                    },
                   
                ],
                retell : [
                    {
                        label: "Responsiveness",
                        name: "responsiveness",
                        datalabel: 'responsiveness',
                        type: "slider",
                        description: translateContent("retell.responseive.desc"),
                        placeholder: "",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        value : 1,
                        min : 0,
                        max : 1,
                        step : 0.01,
                        marks : {0:"Slow",1:"Fast"} ,
                        valueLabelDisplay :"auto",
                        orderNo : 2,
                    },
                    {
                        label: "Interruption Sensitivity",
                        name: "interruption_sensitivity",
                        datalabel: 'interruption_sensitivity',
                        type: "slider",
                        description: translateContent("retell.interruption.desc"),
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        value : 1,
                        min : 0,
                        max : 1,
                        step :  0.01,
                        marks :{0:"Low",1:"High"},
                        valueLabelDisplay :"auto",
                        orderNo : "speech" + 2,
                    },
                    // {
                    //     label: "Voice Speed",
                    //     name: "voice_speed",
                    //     datalabel: fieldNames['voice_speed'],
                    //     type: "slider",
                    //     description: "Voice.",
                    //     placeholder: "Choose a voice",
                    //     required: false,
                    //     isDisabled: !isAllowEdit,
                    //     autoComplete :"off",
                    //     min : 0,
                    //     max : 2,
                    //     step : 1,
                    //     marks : {0:"0",2:"2"}
                    // },
                    {
                        label: "Enable Speech Normalization",
                        name: "speech_normalization",
                        datalabel: 'speech_normalization',
                        type: "switch",
                        description: translateContent("retell.speech.normal.desc"),
                        placeholder: "",
                        required: false,
                        isDisabled: !isAllowEdit,
                        orderNo : 5,
                    },
                   
                    {
                        label: "Reminder Message Frequency",
                        name: "remainder_msg_frequency",
                        datalabel: 'Reminder Message Frequency',
                        type: "input_box",
                        description: translateContent("retell.reminder.msg.desc"),
                        placeholder: "",
                        required: false,
                        isDisabled: !isAllowEdit,
                        orderNo : 6,
                        fields : [
                            {
                                label: "seconds",
                                name: "remainder_msg_frequency_seconds",
                                datalabel: 'remainder_msg_frequency_seconds',
                                type: "number",
                                description: "",
                                placeholder: "",
                                required: false,
                                isDisabled: !isAllowEdit,
                                value : 10,
                                autoComplete :"off",
                            },
                            {
                                label: "times",
                                name: "remainder_msg_frequency_seconds_times",
                                datalabel: 'remainder_msg_frequency_seconds_times',
                                type: "number",
                                description: "",
                                placeholder: "",
                                required: false,
                                isDisabled: !isAllowEdit,
                                value : 1,
                                autoComplete :"off",
                            },
                        ]
                    },
                   
                 
                    {
                        label: "Pronunciation",
                        name: "pronunciation",
                        datalabel: 'pronunciation',
                        type: "buttonModal",
                        description: translateContent("retell.pronunciation.desc"),
                        placeholder: "Enter pronunciation",
                        required: false,
                        isDisabled: !isAllowEdit,
                        orderNo : 7,
                    },
                    {
                        label: "Enable Backchanneling",
                        name: "backchanneling",
                        datalabel: 'backchanneling',
                        type: "switch",
                        description: translateContent("retell.enable.backchannel.desc"),
                        placeholder: "",
                        subFields : [
                            {
                                label: "Backchannel Frequency",
                                name: "backchannel_frequency",
                                datalabel: 'backchannel_frequency',
                                type: "slider",
                                description: "",
                                placeholder: "",
                                required: true,
                                value : 0.8,
                                isDisabled: !isAllowEdit,
                                min : 0,
                                max : 1,
                                step : 0.1,
                                marks : {0: "Low",1:"High"}
                            },
                            {
                                label: "Backchannel Words",
                                name: "backchannel_words",
                                datalabel: 'backchannel_words',
                                type: "text",
                                description: "A list of words that the agent would use for backchanneling.",
                                placeholder: "Split by comma. Example: yeah,uh-huh,okay",
                                required: false,
                                isDisabled: !isAllowEdit,
                            },
                        ],
                        required: false,
                        isDisabled: !isAllowEdit,
                        orderNo : 4,
                    },
                ],
                vapi : [
                    {
                        label: "Background Denoising Enabled",
                        name: "filter_background_noice",
                        datalabel: 'filter_background_noice',
                        type: "switch",
                        description: translateContent("vapi.background.denoising.desc"),
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        orderNo : 2,
                    },
                    {
                        label: "Idle Messages",
                        name: "idle_message",
                        datalabel: 'idle_message',
                        type: "dropdown",
                        description: translateContent("vapi.idle.msg.desc"),
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        options :[
                            { value: "all", label: "(Select All)" },
                            { value: "Are you still there?", label: "Are you still there?" },
                            { value: "Is there anything else you need help with?", label: "Is there anything else you need help with?" },
                            { value: "Feel free to ask me any questions.", label: "Feel free to ask me any questions." },
                            { value: "How can I assist you further?", label: "How can I assist you further?" },
                            { value: "Let me know if there's anything you need.", label: "Let me know if there's anything you need." },
                            { value: "I'm still here if you need assistance.", label: "I'm still here if you need assistance." },
                            { value: "I'm ready to help whenever you are.", label: "I'm ready to help whenever you are." },
                            { value: "Is there something specific you're looking for?", label: "Is there something specific you're looking for?" },
                            { value: "I'm here to help with any questions you have.", label: "I'm here to help with any questions you have." }
                        ],
                        allowMulti : true,
                        orderNo : 3,
                    },
                    {
                        label: "Max Idle Messages",
                        name: "idle_max_message",
                        datalabel: 'idle_max_message',
                        type: "slider",
                        description: translateContent("vapi.maxidle.msg.desc"),
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        value : 1,
                        min : 1,
                        max : 10,
                        step : 1,
                        marks : {1:"1",10:"10"},
                        orderNo : 4,
                    },
                    {
                        label: providerName == "vapi" ? "Idle Timeout" : "",
                        name: "idle_timeout",
                        datalabel: 'idle_timeout',
                        type: "slider",
                        description: translateContent("vapi.idle.timeout.desc"),
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        value : 10,
                        min : 5,
                        max : 60,
                        step : 1,
                        marks : {5: "5 (sec)",10:"60 (sec)"},
                        orderNo : 5,
                    },
                   
                ],
                bland : [
                ],
            },
            callSettingsFields: {
                 common : [
                    {
                        label: "Voicemail Detection",
                        name: "voicemail_detection",
                        datalabel: 'voicemail_detection',
                        type: "switch",
                        description: translateContent("common.voicemail.desc"),
                        placeholder: "",
                        required: true,
                        value : providerName == "vapi" ? "vapi" : "",
                        subFields : {
                            "retell" : [
                                {
                                    label: "Hang up if reaching voicemail",
                                    name: "voice_hang",
                                    type: "radio",
                                    value : "hang",
                                    isDisabled: !isAllowEdit,
                                },
                                {
                                    label: "Leave a message if reaching voicemail",
                                    name: "voice_leave",
                                    type: "radio",
                                    value : "leave",
                                    isDisabled: !isAllowEdit,
                                },
                                {
                                    label: "",
                                    name: "voicemail_message",
                                    datalabel: 'voicemail_message',
                                    type: "textarea",
                                    description: "",
                                    placeholder: "Enter Voicemail message",
                                    required: true,
                                    isDisabled: !isAllowEdit,
                                },
                                /* {
                                    label: "Voicemail Detection Duration",
                                    name: "voicemail_duration",
                                    datalabel: 'voicemail_duration',
                                    type: "slider",
                                    description: "Duration for which voicemail detection will be active during the call",
                                    placeholder: "Voicemail Duration",
                                    required: true,
                                    isDisabled: !isAllowEdit,
                                    value : 0,
                                    min : 5,
                                    max : 180,
                                    step : 1,
                                    marks : {5: "5 (sec)",180:"180 (sec)"}
                                }, */
                            ],
                            "vapi" : [
                                {
                                    label: "Voicemail Message",
                                    name: "vapi_voicemail_message",
                                    datalabel: 'vapi_voicemail_message',
                                    type: "textarea",
                                    tip: translateContent("vapi.voicemail.msg.tip"),
                                    placeholder: "Enter Voicemail message",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                },
                                {
                                    label: "Initial Detection Delay",
                                    name: "initial_detection_delay",
                                    datalabel: 'initial_detection_delay',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 5,
                                    min : 0,
                                    max : 20,
                                    step : 1,
                                    marks : {0:"0 (sec)",20:"20 (sec)"},
                                    tip : translateContent("vapi.init.delay.tip"),
                                },
                                {
                                    label: "Detection Retry Interval",
                                    name: "detection_retry_interval",
                                    datalabel: 'detection_retry_interval',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 5.0,
                                    min : 2.5,
                                    max : 20,
                                    step : 0.5,
                                    marks : {2.5:"2.5 (sec)",20:"20 (sec)"},
                                    tip : translateContent("vapi.detection.retry.tip"),
                                },
                                {
                                    label: "Max Detection Retries",
                                    name: "max_detection_retries",
                                    datalabel: 'max_detection_retries',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 6,
                                    min : 1,
                                    max : 10,
                                    step : 1,
                                    // marks : {1:"0",10:"2"},
                                    tip : translateContent("vapi.maxdetection.retry.tip"),
                                },
                                {
                                    label: "Max Voicemail Message Wait",
                                    name: "max_voicemail_msg_wait",
                                    datalabel: 'max_voicemail_msg_wait',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 0,
                                    min : 0,
                                    max : 30,
                                    step : 1,
                                    marks : {0:"0 (sec)",30:"30 (sec)"},
                                    tip : translateContent("vapi.maxvm.wait.tip"),
                                },
                            ]
                        },
                        isDisabled: !isAllowEdit,
                        orderNo : providerName == "vapi" ? "call-"+ 2 : "call-"+ 6,
                    }, 
                    {
                        label: providerName == "vapi" ? "Maximum Duration" : "Max Call Duration",
                        name: "max_duration",
                        datalabel: 'max_duration',
                        type: "slider",
                        description: providerName == "vapi" ? translateContent("vapi.max.duration.desc") : translateContent("retell.max.call.desc"),
                        placeholder: "Name Here",
                        required: false,
                        isDisabled: !isAllowEdit,
                        value : 4000,
                        min : providerName != 'retell' ? 10 : 60,
                        max : providerName != 'retell' ? 43200 : 7200,
                        step : 10,
                        marks :providerName != 'retell' ?  {10:"10 (sec)",43200:"43200 (sec)"} : {60:"60 (sec)",7200:"7200 (sec)"},
                        orderNo : providerName == "vapi" ? "call-"+ 6 : "call-"+2,
                    },
                    {
                        label: providerName == "vapi" ? "Silence Timeout" : "End Call on Silence",
                        name: "silence_timeout",
                        datalabel: 'silence_timeout',
                        type: "slider",
                        description: providerName == "vapi" ? translateContent("vapi.silence.timeout.desc") : translateContent("retell.silence.timeout.desc"),
                        placeholder: "",
                        required: false,
                        isDisabled: !isAllowEdit,
                        value : 600,
                        autoComplete :"off",
                        min : 10,
                        max : providerName != 'retell' ? 3600 :1800,
                        step : 10,
                        marks : providerName != 'retell' ? {10:"10 (sec)",3600:"3600 (sec)"} : {10:"10 (sec)",1800:"1800 (sec)"},
                        orderNo : providerName == "vapi" ? "call-"+ 5 : "call-"+ 1,
                    },
                  
                ],
                retell : [
                    {
                        label: "Pause Before Speaking",
                        name: "pause_before_speaking",
                        datalabel: 'pause_before_speaking',
                        type: "slider",
                        description: translateContent("retell.pause.before.speak.desc"),
                        placeholder: "",
                        required: false,
                        isDisabled: !isAllowEdit,
                        value : 0,
                        autoComplete :"off",
                        min : 0,
                        max : 5,
                        step : 0.1,
                        marks : {0: "0 (sec)",5:"5 (sec)"},
                        orderNo : 3,
                    },
                    {
                        label: "User Keypad Input Detection",
                        name: "user_input_key_detection",
                        datalabel: 'user_input_key_detection',
                        type: "switch",
                        description: "",
                        placeholder: "",
                        required: true,
                        subFields : [
                            {
                                label: "Timeout",
                                name: "user_input_timeout",
                                datalabel: 'user_input_timeout',
                                type: "slider",
                                description: "The AI will respond if no keypad input is detected within the set time.",
                                placeholder: "",
                                required: true,
                                isDisabled: !isAllowEdit,
                                value : 1,
                                min : 1,
                                max : 15,
                                step : 0.5,
                                marks : {1: "1 (sec)",15:"15 (sec)"}
                            },
                            {
                                label: "Termination Key",
                                name: "user_input_termination_key",
                                datalabel: 'user_input_termination_key',
                                type: "switch",
                                description: "The AI will respond when the user presses the configured termination key (0-9, #, *).",
                                placeholder: "",
                                required: false,
                                isDisabled: !isAllowEdit,
                                subInFields : [
                                    {
                                        label: "",
                                        name: "user_input_termination_key_count",
                                        datalabel: 'user_input_termination_key_count',
                                        type: "dropdown",
                                        description: "",
                                        placeholder: "",
                                        required: false,
                                        isDisabled: !isAllowEdit,
                                        autoComplete :"off",
                                        options :[
                                            { value: "0", label: "0" },
                                            { value: "1", label: "1" },
                                            { value: "2", label: "2" },
                                            { value: "3", label: "3" },
                                            { value: "4", label: "4" },
                                            { value: "5", label: "5" },
                                            { value: "6", label: "6" },
                                            { value: "7", label: "7" },
                                            { value: "8", label: "8" },
                                            { value: "9", label: "9" },
                                            { value: "#", label: "#" },
                                            { value: "*", label: "*" },
                                        ],
                                        allowMulti : false,
                                        isClear : false,
                                    },
                                ],
                                orderNo : 1,
                            },
                            {
                                label: "Digit Limit",
                                name: "user_input_termination_key_digit_limit",
                                datalabel: 'user_input_termination_key_digit_limit',
                                type: "switch",
                                description: "The AI will respond immediately after the caller enters the configured number of digits.",
                                placeholder: "",
                                required: false,
                                isDisabled: !isAllowEdit,
                                subInFields : [
                                    {
                                        label: "",
                                        name: "user_input_termination_key_digit_limit_count",
                                        datalabel: 'user_input_termination_key_digit_limit_count',
                                        type: "numericInput",
                                        description: "",
                                        placeholder: "",
                                        required: false,
                                        isDisabled: !isAllowEdit,
                                        autoComplete :"off",
                                        allowMulti : true,
                                        min : 10,
                                        max : 50,
                                        value : 20,
                                    },
                                ],
                            },
                        ],
                        isDisabled: !isAllowEdit,
                        orderNo : 7,
                    },
                    {
                        label: "Ring Duration",
                        name: "ring_duration",
                        datalabel: 'ring_duration',
                        type: "slider",
                        description: translateContent("retell.ring.duration.desc"),
                        placeholder: "",
                        required: false,
                        isDisabled: !isAllowEdit,
                        value : 30,
                        autoComplete :"off",
                        min : 5,
                        max : 90,
                        step : 1,
                        marks : {5: "5 (sec)",90:"90 (sec)"},
                        orderNo : 4,
                    },
                ],
                vapi : [
                    {
                        label: "Wait Seconds",
                        name: "wait_seconds",
                        datalabel: 'wait_seconds',
                        type: "slider",
                        description: translateContent("vapi.waitsec.desc"),
                        placeholder: "",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        value : 0.4,
                        min : 0,
                        max : 5,
                        step : 0.1,
                        marks : {0: "0 (sec)",5:"5 (sec)"},
                        orderNo : 1,
                    },
                    {
                        label: "Back off Seconds",
                        name: "interruption_sensitivity",
                        datalabel: 'interruption_sensitivity',
                        type: "slider",
                        description:translateContent("vapi.backoff.desc"),
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        value : 1,
                        min : 0,
                        max :10 ,
                        step : 1,
                        marks : {0:"0 (sec)",10:"10 (sec)"} ,
                        valueLabelDisplay :"auto",
                        orderNo : "speech" + 4,
                    },
                    /* {
                        label: providerName == "vapi" ? "Idle Timeout" : "",
                        name: "idle_timeout",
                        datalabel: 'idle_timeout',
                        type: "slider",
                        description: "Idle Timeout",
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        value : 10,
                        min : 5,
                        max : 60,
                        step : 1,
                        marks : {5: "5 (sec)",10:"60 (sec)"},
                        orderNo : 6,
                    }, */
                    {
                        label: "Number of words",
                        name: "num_words",
                        datalabel: 'num_words',
                        type: "slider",
                        description: "This is the number of words that the customer has to say before the agent will stop talking",
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        readableDuration:false,
                        value : 0,
                        min : 0,
                        max : 10,
                        step : 1,
                        marks : {0:"0",10:"10"},
                        orderNo : 2
                    },
                    {
                        label: "Voice Seconds",
                        name: "voice_seconds",
                        datalabel: 'voice_seconds',
                        type: "slider",
                        description: "This is the seconds customer has to speak before the agent stops talking.",
                        placeholder: "Choose a voice",
                        required: false,
                        isDisabled: !isAllowEdit,
                        autoComplete :"off",
                        value : 0.1,
                        min : 0,
                        max : 0.5,
                        step : 0.1,
                        marks : {0:"0 (sec)",0.5:"0.5 (sec)"},
                        orderNo : 3,
                    },
                    /* {
                        label: "Voicemail Detection",
                        name: "voicemail_detection",
                        datalabel: 'voicemail_detection',
                        type: "switch",
                        description: translateContent("common.voicemail.desc"),
                        placeholder: "",
                        required: true,
                        value : providerName == "vapi" ? "vapi" : "",
                        subFields : {
                            "vapi" : [
                                {
                                    label: "Voicemail Message",
                                    name: "vapi_voicemail_message",
                                    datalabel: 'vapi_voicemail_message',
                                    type: "textarea",
                                    tip: translateContent("vapi.voicemail.msg.tip"),
                                    placeholder: "Enter Voicemail message",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                },
                                {
                                    label: "Initial Detection Delay",
                                    name: "initial_detection_delay",
                                    datalabel: 'initial_detection_delay',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 5,
                                    min : 0,
                                    max : 20,
                                    step : 1,
                                    marks : {0:"0 (sec)",20:"20 (sec)"},
                                    tip : translateContent("vapi.init.delay.tip"),
                                },
                                {
                                    label: "Detection Retry Interval",
                                    name: "detection_retry_interval",
                                    datalabel: 'detection_retry_interval',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 5.0,
                                    min : 2.5,
                                    max : 20,
                                    step : 0.5,
                                    marks : {2.5:"2.5 (sec)",20:"20 (sec)"},
                                    tip : translateContent("vapi.detection.retry.tip"),
                                },
                                {
                                    label: "Max Detection Retries",
                                    name: "max_detection_retries",
                                    datalabel: 'max_detection_retries',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 6,
                                    min : 1,
                                    max : 10,
                                    step : 1,
                                    // marks : {1:"0",10:"2"},
                                    tip : translateContent("vapi.maxdetection.retry.tip"),
                                },
                                {
                                    label: "Max Voicemail Message Wait",
                                    name: "max_voicemail_msg_wait",
                                    datalabel: 'max_voicemail_msg_wait',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 0,
                                    min : 0,
                                    max : 30,
                                    step : 1,
                                    marks : {0:"0 (sec)",30:"30 (sec)"},
                                    tip : translateContent("vapi.maxvm.wait.tip"),
                                },
                            ]
                        },
                        isDisabled: !isAllowEdit,
                        orderNo : providerName == "vapi" ? "call-"+ 7 : "call-"+ 6,
                    }, */
                ],
            },
            advancedSettingsFields : [
                {
                    label: "Server URL",
                    name: "server_url",
                    type: "text",
                    description: "This is the URL that will be used to communicate messages via HTTP POST requests for retrieving context, making function calls, and generating end-of-call reports.",
                    placeholder: "Give a webhook URL",
                    required: true,
                    autoComplete :"off"
                },
                {
                    label: "Server URL Secret",
                    name: "secret",
                    type: "text",
                    description: "For security reasons, you can set a secret key to be sent with each request to the server URL as header X-SECRET.",
                    placeholder: "Give a webhook URL Secret",
                    required: true,
                    autoComplete :"off"
                },
            ],
            agentSettingsFields : 
                { 
                    retell : [
                        {
                            label: "Model",
                            name: "model_name",
                            datalabel: 'model_name',
                            type: "dropdown",
                            description: "AI Modal Name",
                            required: false,
                            isDisabled: false,
                            options : pickListItems["Agent_Master_Model_Provider_"+providerName]?.["all"],//agentScreenDrpDown["vapiModals"][dropDownName],
                            allowMulti : false,
                        },
                        {
                            label: "LLM Temperature",
                            name: "llm_temprature",
                            datalabel: 'llm_temprature',
                            type: "slider",
                            value : 0,
                            description: "Lower value yields better function call results.",
                            placeholder: "",
                            required: true,
                            isDisabled: false,
                            min : 0,
                            max : 1,
                            step : 0.1,
                            marks : {0:"Low",2:"High"},
                        },
                        // {
                        //     label: "High Priority",
                        //     name: "modal_high_priority",
                        //     datalabel: 'modal_high_priority',
                        //     type: "switch",
                        //     description: "",
                        //     placeholder: "",
                        //     required: false,
                        //     isDisabled: false,
                        // },
                        // {
                        //     label: "LLM ID",
                        //     name: "llm_id",
                        //     datalabel: 'llm_id',
                        //     type: "text",
                        //     description: "Agent LLM ID",
                        //     // placeholder: "Choose a voice",
                        //     required: false,
                        //     isDisabled: true,
                        // },
                    ],
                    vapi : [
                        {
                            label: "Provider",
                            name: "vapi_modal_provider",
                            datalabel: 'vapi_modal_provider',
                            type: "dropdown",
                            // description: "AI Modal Provider",
                            // placeholder: "Name Here",
                            required: false,
                            isDisabled: false,
                            options : pickListItems["Agent_Master_Model_Provider_New"],//agentScreenDrpDown["vapiModalProviders"],
                            allowMulti : false,
                        },
                        {
                            label: "Model",
                            name: "vapi_model_name",
                            datalabel: 'vapi_model_name',
                            type: "dropdown",
                            // description: "AI Modal Name",
                            required: false,
                            isDisabled: false,
                            options : pickListItems["Agent_Master_Model_Provider_"+providerName]?.[dropDownName],//agentScreenDrpDown["vapiModals"][dropDownName],
                            allowMulti : false,
                        },
                        {
                            label: "Temperature",
                            name: "modal_temperature",
                            datalabel: 'modal_temperature',
                            type: "slider",
                            value : 0,
                            description: translateContent("vapi.temp.desc"),
                            placeholder: "Name Here",
                            required: false,
                            isDisabled: !isAllowEdit,
                            min : 0,
                            max : 2,
                            step : 0.1,
                            marks : {0:"Low",2:"High"},
                            orderNo : 2,
                        },
                        // {
                        //     label: "Transcriber Name",
                        //     name: "transcription_model",
                        //     datalabel: 'transcription_model',
                        //     type: "text",
                        //     description: "Transcription Modal Name",
                        //     // placeholder: "Name Here",
                        //     required: false,
                        //     isDisabled: true,
                        // },
                        // {
                        //     label: "Transcriber Provider",
                        //     name: "transcription_provider",
                        //     datalabel: 'transcription_provider',
                        //     type: "text",
                        //     description: "Transcription Modal Provider",
                        //     // placeholder: "Name Here",
                        //     required: false,
                        //     isDisabled: true,
                        // }
                    ],
                },
            pronunciationFields : [
                {
                    label: "Word",
                    name: "word",
                    datalabel: 'word',
                    type: "text",
                    description: "",
                    placeholder: "Enter Word",
                    required: true,
                    isDisabled: !isAllowEdit,
                    autoComplete :"off",
                },
                {
                    label: "Pronunciation",
                    name: "alphabet",
                    type: "dropdown",
                    description: "Guide the model to pronunce a word, name, or phrase in a specific way.",
                    required: false,
                    isDisabled: !isAllowEdit,
                    autoComplete :"off",
                    options :[
                        { value: "ipa", label: "IPA" },
                        { value: "cmu", label: "CMU" },
                    ],
                },
                {
                    label: "Phoneme",
                    name: "phoneme",
                    datalabel: 'phoneme',
                    type: "text",
                    description: "",
                    placeholder: "Enter Phoneme",
                    required: true,
                    isDisabled: !isAllowEdit,
                    autoComplete :"off",
                },
            ],  
            callMappings : [
                { type: "outgoing", label: "Assign Outbound Phone Numbers",description:"Link one or more phone numbers to initiate outgoing calls." },
                { type: "incoming", label: "Assign Inbound Phone Numbers",description:"Link one or more phone numbers to receive incoming calls from users." },
            ],
            transcriptionSettingsFields:{
                retell:[
                    {
                        label: "Denoising Mode",
                        name: "denoicing_mode",
                        datalabel: 'denoicing_mode',
                        type: "subField",
                        description: translateContent("retell.denoise.desc"),
                        placeholder: "Enter mode",
                        required: true,
                        subFields : [
                            {
                                label: "Remove noise",
                                name: "remove_noise",
                                datalabel: 'remove_noise',
                                type: "radio",
                                value : "noise-cancellation",
                                isDisabled: !isAllowEdit,
                            },
                            {
                                label: "Remove noise + background speech",
                                name: "remove_noise_back_speech",
                                datalabel: 'remove_noise_back_speech',
                                type: "radio",
                                value : "noise-and-background-speech-cancellation",
                                isDisabled: !isAllowEdit,
                            },
                        ],
                        isDisabled: !isAllowEdit,
                        orderNo : 1,
                    },
                    {
                        label: "Transcription Mode",
                        name: "transcription_mode",
                        datalabel: 'transcription_mode',
                        type: "subField",
                        description: translateContent("retell.transcrption.desc"),
                        placeholder: "Enter mode",
                        required: true,
                        subFields : [
                            {
                                label: "Optimize for speed",
                                name: "transcription_speed",
                                datalabel: 'transcription_speed',
                                type: "radio",
                                value : "fast",
                                isDisabled: !isAllowEdit,
                            },
                            {
                                label: "Optimize for accuracy",
                                name: "transcription_accuracy",
                                datalabel: 'transcription_accuracy',
                                type: "radio",
                                value : "accurate",
                                isDisabled: !isAllowEdit,
                            },
                        ],
                        isDisabled: !isAllowEdit,
                        orderNo : 2,
                    },
                    {
                        label: "Boosted Keywords",
                        name: "boosted_keywords",
                        datalabel: 'boosted_keywords',
                        type: "text",
                        description: "Provide a customized list of keywords to expand our models' vocabulary.",
                        placeholder: "Split by comma.Ex good,nature",
                        required: false,
                        isDisabled: !isAllowEdit,
                        orderNo : 3,
                    },
                    /*  {
                        label: "Enable Transcript Formatting",
                        name: "transcript_formatting",
                        datalabel: 'transcript_formatting',
                        type: "switch",
                        description: translateContent("retell.enable.transcript.format.desc"),
                        placeholder: "",
                        required: false,
                        isDisabled: !isAllowEdit,
                        orderNo : 4,
                    },
                    {
                        label: "Voicemail Detection",
                        name: "voicemail_detection",
                        datalabel: 'voicemail_detection',
                        type: "switch",
                        description: translateContent("common.voicemail.desc"),
                        placeholder: "",
                        required: true,
                        value : providerName == "vapi" ? "vapi" : "",
                        subFields : {
                            "retell" : [
                                {
                                    label: "Hang up if reaching voicemail",
                                    name: "voice_hang",
                                    type: "radio",
                                    value : "hang",
                                    isDisabled: !isAllowEdit,
                                },
                                {
                                    label: "Leave a message if reaching voicemail",
                                    name: "voice_leave",
                                    type: "radio",
                                    value : "leave",
                                    isDisabled: !isAllowEdit,
                                },
                                {
                                    label: "",
                                    name: "voicemail_message",
                                    datalabel: 'voicemail_message',
                                    type: "textarea",
                                    description: "",
                                    placeholder: "Enter Voicemail message",
                                    required: true,
                                    isDisabled: !isAllowEdit,
                                },
                                {
                                    label: "Voicemail Detection Duration",
                                    name: "voicemail_duration",
                                    datalabel: 'voicemail_duration',
                                    type: "slider",
                                    description: "Duration for which voicemail detection will be active during the call",
                                    placeholder: "Voicemail Duration",
                                    required: true,
                                    isDisabled: !isAllowEdit,
                                    value : 0,
                                    min : 5,
                                    max : 180,
                                    step : 1,
                                    marks : {5: "5 (sec)",180:"180 (sec)"}
                                },
                            ],
                            "vapi" : [
                                {
                                    label: "Voicemail Message",
                                    name: "vapi_voicemail_message",
                                    datalabel: 'vapi_voicemail_message',
                                    type: "textarea",
                                    tip: translateContent("vapi.voicemail.msg.tip"),
                                    placeholder: "Enter Voicemail message",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                },
                                {
                                    label: "Initial Detection Delay",
                                    name: "initial_detection_delay",
                                    datalabel: 'initial_detection_delay',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 5,
                                    min : 0,
                                    max : 20,
                                    step : 1,
                                    marks : {0:"0 (sec)",20:"20 (sec)"},
                                    tip : translateContent("vapi.init.delay.tip"),
                                },
                                {
                                    label: "Detection Retry Interval",
                                    name: "detection_retry_interval",
                                    datalabel: 'detection_retry_interval',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 5.0,
                                    min : 2.5,
                                    max : 20,
                                    step : 0.5,
                                    marks : {2.5:"2.5 (sec)",20:"20 (sec)"},
                                    tip : translateContent("vapi.detection.retry.tip"),
                                },
                                {
                                    label: "Max Detection Retries",
                                    name: "max_detection_retries",
                                    datalabel: 'max_detection_retries',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 6,
                                    min : 1,
                                    max : 10,
                                    step : 1,
                                    // marks : {1:"0",10:"2"},
                                    tip : translateContent("vapi.maxdetection.retry.tip"),
                                },
                                {
                                    label: "Max Voicemail Message Wait",
                                    name: "max_voicemail_msg_wait",
                                    datalabel: 'max_voicemail_msg_wait',
                                    type: "slider",
                                    description: "",
                                    placeholder: "Name Here",
                                    required: false,
                                    isDisabled: !isAllowEdit,
                                    value : 0,
                                    min : 0,
                                    max : 30,
                                    step : 1,
                                    marks : {0:"0 (sec)",30:"30 (sec)"},
                                    tip : translateContent("vapi.maxvm.wait.tip"),
                                },
                            ]
                        },
                        isDisabled: !isAllowEdit,
                        orderNo : providerName == "vapi" ? "call-"+ 2 : "call-"+ 6,
                    }, */
                ],
            }
        };
    };
    export const providerLanguages = {
        "vapi":[
            { value: "en-US", label: "🇺🇸 English (United States)" },
            { value: "es", label: "🇪🇸 Spanish (Spain)" },
            { value: "en-IN", label: "🇮🇳 English (India)" },
            { value: "en-GB", label: "🇬🇧 English (United Kingdom)" },
            { value: "en-AU", label: "🇦🇺 English (Australia)" },
            { value: "en-NZ", label: "🇳🇿 English (New Zealand)" },
            { value: "fr", label: "🇫🇷 French (France)" },
            { value: "zh-CN", label: "🇨🇳 Chinese (China)" },
            { value: "de", label: "🇩🇪 German (Germany)" },
            { value: "hi", label: "🇮🇳 Hindi (India)" },
            { value: "ja", label: "🇯🇵 Japanese (Japan)" },
            { value: "pt-BR", label: "🇧🇷 Portuguese (Brazil)" },
            { value: "pt", label: "🇵🇹 Portuguese (Portugal)" },
            { value: "ru", label: "🇷🇺 Russian (Russia)" },
            { value: "it", label: "🇮🇹 Italian (Italy)" }
        ],
        "retell":[
            { value: "en-US", label: "🇺🇸 English (United States)" },
            { value: "es-ES", label: "🇪🇸 Spanish (Spain)" },
            { value: "en-IN", label: "🇮🇳 English (India)" },
            { value: "en-GB", label: "🇬🇧 English (United Kingdom)" },
            { value: "en-AU", label: "🇦🇺 English (Australia)" },
            { value: "en-NZ", label: "🇳🇿 English (New Zealand)" },
            { value: "fr-FR", label: "🇫🇷 French (France)" },
            { value: "zh-CN", label: "🇨🇳 Chinese (China)" },
            { value: "de-DE", label: "🇩🇪 German (Germany)" },
            { value: "hi-IN", label: "🇮🇳 Hindi (India)" },
            { value: "ja-JP", label: "🇯🇵 Japanese (Japan)" },
            { value: "pt-BR", label: "🇧🇷 Portuguese (Brazil)" },
            { value: "pt-PT", label: "🇵🇹 Portuguese (Portugal)" },
            { value: "ru-RU", label: "🇷🇺 Russian (Russia)" },
            { value: "it-IT", label: "🇮🇹 Italian (Italy)" }
        ]
    };

export const showSettingsMinFields = ["agentSettings","callSettings","speechSettings","transcriptionFields"];
export const showAgencySettingsHideFields = [];
export const agentScreenDrpDown = {
    "welcomeMsgList" : [
        { value: "0", label: "User Initiates: AI remains silent until users speak first." },
        { value: "1", label: "AI Initiates: AI begins with a dynamic begin message." },
        { value: "msg", label: "AI Initiates: AI begins with your defined begin message." },
    ],
    "vapiModalProviders" : [
        { value: "anthropic", label: "Anthropic" },
        { value: "google", label: "Google" },
        { value: "openai", label: "OpenAi" },
    ],
    "vapiModals" : {
        "anthropic" :
            [
                { "value": "claude-3-5-haiku-20241022", "label": "claude-3.5-haiku" },
                { "value": "claude-3-5-sonnet-20241022", "label": "claude-3.5-sonnet" },
                // { "value": "claude-3-5-sonnet-20240620", "label": "claude-3-5-sonnet-20240620" },
                // { "value": "claude-3-7-sonnet-20250219", "label": "claude-3-7-sonnet-20250219" },
                // { "value": "claude-3-haiku-20240307", "label": "claude-3-haiku-20240307" },
                // { "value": "claude-3-opus-20240229", "label": "claude-3-opus-20240229" },
                // { "value": "claude-3-sonnet-20240229", "label": "claude-3-sonnet-20240229" },
                // { "value": "claude-opus-4-20250514", "label": "claude-opus-4-20250514" },
                // { "value": "claude-sonnet-4-20250514", "label": "claude-sonnet-4-20250514" }
            ],
        "google" :
            [
                { "value": "gemini-2.0-flash", "label": "Gemini 2.0 Flash" },
                { "value": "gemini-2.0-flash-lite", "label": "Gemini 2.0 Flash Lite" },
                // { "value": "gemini-1.0-pro", "label": "Gemini 1.0 Pro" },
                // { "value": "gemini-1.5-flash", "label": "Gemini 1.5 Flash" },
                // { "value": "gemini-1.5-flash-002", "label": "Gemini 1.5 Flash 002" },
                // { "value": "gemini-1.5-pro", "label": "Gemini 1.5 Pro" },
                // { "value": "gemini-1.5-pro-002", "label": "Gemini 1.5 Pro 002" },
                // { "value": "gemini-2.0-flash-exp", "label": "Gemini 2.0 Flash Exp" },
                // { "value": "gemini-2.0-flash-lite-preview-02-05", "label": "Gemini 2.0 Flash Lite Preview 02 05" },
                // { "value": "gemini-2.0-flash-realtime-exp", "label": "Gemini 2.0 Flash Realtime Exp" },
                // { "value": "gemini-2.0-flash-thinking-exp", "label": "Gemini 2.0 Flash Thinking Exp" },
                // { "value": "gemini-2.0-pro-exp-02-05", "label": "Gemini 2.0 Pro Exp 02 05" },
                // { "value": "gemini-2.5-flash-preview-04-17", "label": "Gemini 2.5 Flash Preview 04 17" },
                // { "value": "gemini-2.5-pro-preview-05-06", "label": "Gemini 2.5 Pro Preview 05 06" }
            ],
        "openai" : 
            [
                { value: "gpt-4.1", label: "GPT 4.1" },
                { value: "gpt-4.1-mini", label: "GPT 4.1 Mini" },
                { value: "gpt-4.1-nano", label: "GPT 4.1 Nano" },
                { value: "gpt-4o", label: "GPT 4o" },
                // { value: "chatgpt-4o-latest", label: "Chatgpt 4o Latest" },
                // { value: "gpt-3.5-turbo", label: "GPT 3.5 Turbo" },
                // { value: "gpt-3.5-turbo-0125", label: "GPT 3.5 Turbo 0125" },
                // { value: "gpt-3.5-turbo-0613", label: "GPT 3.5 Turbo 0613" },
                // { value: "gpt-3.5-turbo-1106", label: "GPT 3.5 Turbo 1106" },
                // { value: "gpt-3.5-turbo-16k", label: "GPT 3.5 Turbo 16k" },
                // { value: "gpt-4", label: "GPT 4" },
                // { value: "gpt-4-0125-preview", label: "GPT 4 0125 Preview" },
                // { value: "gpt-4-0613", label: "GPT 4 0613" },
                // { value: "gpt-4-1106-preview", label: "GPT 4 1106 Preview" },
                // { value: "gpt-4-turbo", label: "GPT 4 Turbo" },
                // { value: "gpt-4-turbo-2024-04-09", label: "GPT 4 Turbo 2024 04 09" },
                // { value: "gpt-4-turbo-preview", label: "GPT 4 Turbo Preview" },               
                // { value: "gpt-4.5-preview", label: "GPT 4.5 Preview" },
                // { value: "gpt-4o-2024-05-13", label: "GPT 4o 2024 05 13" },
                // { value: "gpt-4o-2024-08-06", label: "GPT 4o 2024 08 06" },
                // { value: "gpt-4o-2024-11-20", label: "GPT 4o 2024 11 20" },
                // { value: "gpt-4o-mini", label: "GPT 4o Mini" },
                // { value: "gpt-4o-mini-2024-07-18", label: "GPT 4o Mini 2024 07 18" },
                // { value: "gpt-4o-mini-realtime-preview-2024-12-17", label: "GPT 4o Mini Realtime Preview 2024 12 17" },
                // { value: "gpt-4o-realtime-preview-2024-10-01", label: "GPT 4o Realtime Preview 2024 10 01" },
                // { value: "gpt-4o-realtime-preview-2024-12-17", label: "GPT 4o Realtime Preview 2024 12 17" },
                // { value: "o1-mini", label: "O1 Mini" },
                // { value: "o1-mini-2024-09-12", label: "O1 Mini 2024 09 12" },
                // { value: "o1-preview", label: "O1 Preview" },
                // { value: "o1-preview-2024-09-12", label: "O1 Preview 2024 09 12" },
                // { value: "o3", label: "O3" },
                // { value: "o3-mini", label: "O3 Mini" },
                // { value: "o4-mini", label: "O4 Mini" }                 
            ],
    } 
}
